export default __webpack_public_path__ + "static/media/a-3d1152.f8f99c6a.svg";